import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import axios from 'axios'
import Print from './libs/print.js';
Print.install = function(Vue) {
    Vue.directive('print', Print);
};

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.use(Print);

let echarts = require('echarts')

// let BASE_URL_SERVER = "https://api.shsaien.com";
let BASE_URL_SERVER = "https://api.shsaien.com";
let STATIC_URL_SERVER = "https://erp.shsaien.com/";
let MOBILE_URL_SERVER = "https://m.shsaien.com/";

Vue.prototype.$echarts = echarts
axios.defaults.withCredentials=false
Vue.prototype.$axios = axios
Vue.prototype.$url = BASE_URL_SERVER
Vue.prototype.$static_url = STATIC_URL_SERVER
Vue.prototype.$m_url = MOBILE_URL_SERVER

Vue.prototype.$fileUrlFac = function(url,pid){
  if(url&&url.indexOf('http')===-1){
    return STATIC_URL_SERVER + url +'?id=' + pid;
  }else{
      return url;
    }
  
}

Vue.prototype.$fileUrlFacWithoutRight = function(url){
  if(url.indexOf('http')===-1){
  return STATIC_URL_SERVER + url;}
  else{
    return url;
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export {BASE_URL_SERVER}